import { createContext } from 'react';

const FeatureFlagsContext = createContext('light');

export { FeatureFlagsContext };
